export default function SkeletonChart() {
  return (
    <div className="bg-white dark:bg-background-100 rounded-xl border border-background-200 dark:border-background-300 p-6 animate-pulse">
      <div className="flex items-center justify-between mb-5">
        <div className="space-y-2">
          <div className="h-4 w-32 bg-background-200 dark:bg-background-300 rounded-md" />
          <div className="h-3 w-20 bg-background-200 dark:bg-background-300 rounded-md" />
        </div>
        <div className="flex gap-2">
          <div className="h-8 w-16 bg-background-200 dark:bg-background-300 rounded-lg" />
          <div className="h-8 w-16 bg-background-200 dark:bg-background-300 rounded-lg" />
        </div>
      </div>
      <div className="flex items-end gap-3 h-[220px] pt-4">
        {[60, 75, 50, 85, 70, 40, 55].map((h, i) => (
          <div
            key={i}
            className="flex-1 bg-background-200 dark:bg-background-300 rounded-lg"
            style={{ height: `${h}%` }}
          />
        ))}
      </div>
    </div>
  );
}